export const enviroments = {
    URL_BASE: process.env.NODE_ENV === 'production'
        ? 'https://production.backend.qihotels.net'
        : 'http://localhost:3001'
};

